import React from 'react';

export default function RoundEnd({ round, score, onNext, onExit }) {
  const isLast = round >= 3;

  return (
    <div className="card round-wrap fade-in">
      <p className="title" style={{ fontSize: 14, letterSpacing: 6, color: 'var(--muted)' }}>
        ROUND {round} COMPLETE
      </p>
      <div className="divider" />
      <div className="big-score">{score.toLocaleString()}</div>
      <p style={{ color: 'var(--muted)', marginBottom: 28, fontFamily: "'Rajdhani', sans-serif", letterSpacing: 2 }}>
        TOTAL SCORE
      </p>

      {!isLast && (
        <p style={{ marginBottom: 24, color: 'var(--text)' }}>Ready for Round {round + 1}?</p>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <button className="btn btn-primary" onClick={onNext} style={{ fontSize: 20 }}>
          {isLast ? '⚡ SEE FINAL SCORE' : `⚡ ROUND ${round + 1}`}
        </button>
        <button className="exit-btn" onClick={onExit} style={{ margin: '0 auto' }}>✕ Exit to Menu</button>
      </div>
    </div>
  );
}
